import { render, staticRenderFns } from "./CmChildrenInfo.vue?vue&type=template&id=ec46d75a&scoped=true"
import script from "./CmChildrenInfo.vue?vue&type=script&lang=ts"
export * from "./CmChildrenInfo.vue?vue&type=script&lang=ts"
import style0 from "./CmChildrenInfo.vue?vue&type=style&index=0&id=ec46d75a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec46d75a",
  null
  
)

export default component.exports